// const { version } = require('../../package.json');

// tamaños sacados de: https://myadmin-v3.tappx.com/en/utils/info_creative_sizes
export const SIZES_16_9 = {
  MREC: {
    MOBILE: [
      [300, 250],
      [480, 320],
    ],
    DESKTOP: [
      [300, 250],
      [480, 320],
    ],
  },
  OVERLAY: {
    MOBILE: [
      [300, 50],
      [320, 50],
    ],
    DESKTOP: [
      [300, 50],
      [320, 50],
    ],
  },
};

export const SIZES_9_16 = {
  MREC: {
    MOBILE: [
      [300, 250],
      [320, 480],
    ],
    DESKTOP: [
      [300, 250],
      [320, 480],
    ],
  },
  OVERLAY: {
    MOBILE: [
      [300, 50],
      [320, 50],
    ],
    DESKTOP: [
      [300, 50],
      [320, 50],
    ],
  },
};
